import PropTypes from 'prop-types'
import { Route, Routes } from 'react-router-dom'
import { GenericErrorBoundary } from '../components/2compounds/GenericErrorBoundary'
import GroupCreateForm from '../pages/iam/GroupCreateForm'
import ApproveDashboard from '../pages/dataImportApproval/approveDashboard/ApproveDashboard'
import ApproveFeedback from '../pages/dataImportApproval/approveDashboard/ApproveFeedback'
import Contacts from '../pages/bulkImportRules/Contacts'
import Dashboard from '../pages/bulkImportRules/Dashboard'
import Locations from '../pages/bulkImportRules/Locations'

const routesBySection = {
  approveDashboard: [
    { path: 'feedback/:pendingDataId', Component: ApproveFeedback },
    { path: ':pendingDataId', Component: ApproveDashboard },
  ],
  create: [
    { path: 'group', Component: GroupCreateForm },
  ],
  format: [
    { path: 'locations', Component: Locations },
    { path: 'contacts', Component: Contacts },
    { path: 'dashboard', Component: Dashboard },
  ],
}

const UtilityRoutes = ({ section }) => (
  <Routes>
    {routesBySection[section].map(({ path, Component }) => (
      <Route
        key={path}
        path={path}
        element={(
          <GenericErrorBoundary>
            <Component />
          </GenericErrorBoundary>
        )}
      />
    ))}
  </Routes>
)

UtilityRoutes.propTypes = {
  section: PropTypes.oneOf(Object.keys(routesBySection)).isRequired,
}

export default UtilityRoutes
